/**
 * The four endpoints of the admin API behind the Developers page. They go through the panel's
 * HTTP client, like every other admin call, so they carry the session and the impersonation.
 */

import { httpClient } from '@/utils/httpClient';
import type { DeveloperInfo } from './types';

/** The one place the path prefix lives. */
export const DEVELOPERS_API_BASE = '/admin/developers';

export const developersApi = {
  info: () => httpClient.get<DeveloperInfo>(`${DEVELOPERS_API_BASE}/info`).then((r) => r.data),
  openApi: () => httpClient.get<unknown>(`${DEVELOPERS_API_BASE}/openapi.json`).then((r) => r.data),
  postmanCollection: () => httpClient.get<unknown>(`${DEVELOPERS_API_BASE}/postman/collection.json`).then((r) => r.data),
  postmanEnvironment: (env: string) =>
    httpClient
      .get<unknown>(`${DEVELOPERS_API_BASE}/postman/environment.json?env=${encodeURIComponent(env)}`)
      .then((r) => r.data),
};

/** The message the admin API wrote for the user (`{ error, message }`), when it wrote one. */
export const apiMessage = (error: unknown): string | undefined => {
  const message = (error as { data?: { message?: unknown } } | undefined)?.data?.message;
  return typeof message === 'string' && message.trim() ? message : undefined;
};

/** A body that came back as text (a server that forgot the JSON content type) is parsed here. */
export const asDocument = (data: unknown): unknown => (typeof data === 'string' ? JSON.parse(data) : data);
